import React, { useEffect, useState, useContext, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { StyledCardWIPHistorico } from "../../../styled-components/StyledCardWIPHistorico.style";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { get, set, useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import { useHistory } from "react-router-dom";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { getWIPHistoricoDatas } from "../../../services/wip";
import { getPeritos } from '../../../services/peritos';
import { getUrlParams } from '../../../utils/getUrlParams'
import { getEmpresas } from '../../../services/empresas';
import Swal from "sweetalert2";
import Flex from '@react-css/flex';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { IconRefresh } from "../../../svg";

export const WIPHistorico = () => {
    const { register, handleSubmit, reset } = useForm();
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [isLoading, setisLoading] = useState(true);
    const urlParams = new URLSearchParams(window.location.search);

    var [isSearch, setIsSearch] = useState(false);
    const [datasFotografia, setDataFotografia] = useState(null);
    const [listHistorico, setListHistorico] = useState([]);
    const [empresaList, setEmpresaList] = useState([]);
    const [dataDisponivel, setDataDisponivel] = useState(null);
    const [selectedDataId, setSelectedDataId] = useState(null);
    const [isDataDisponivel, setIsDataDisponivel] = useState(false);
    var [idEmpresa, setEmpresaId] = useState(null);
    var [selectedEmpresa, setselectedEmpresa] = useState(null);

    const formData = async (data) => {
        Promise.all([]).then((values) => {
            setisLoading(false);
        });
    };

    const getEmpresa = async (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedEmpresa(null);
            setEmpresaId(null);
            setDataDisponivel(null);
            setIsDataDisponivel(false);
            setIsSearch(false);
            return;
        }

        var empresaResult = empresaList.filter(async function (o) {
            return o.idEmpresa == value;
        });

        var description = empresaResult[value - 1].description;
        var idEmpresa = empresaResult[value -1].idEmpresa;
        
        setselectedEmpresa(description);
        setEmpresaId(idEmpresa);

        let params = `IdEmpresa=${idEmpresa}`;
        const datasFotografia = await api.get(`Wip/historico/datas-disponiveis?${params}`);
        let resultDatasFotografia = datasFotografia.data.data;
        if (!!resultDatasFotografia) {
            //setIsSearch(false);
            setIsDataDisponivel(true);
            setDataFotografia(resultDatasFotografia);
        }
    };

    const datasDisponiveis = React.useMemo(() => {
        if (!datasFotografia) return [];
        
        // Transformando o objeto em array de datas normalizadas
        return Object.values(datasFotografia).map(str => {
            const d = new Date(str);
            d.setHours(0, 0, 0, 0); 
            return d;
        });
    }, [datasFotografia]);

    const handleDatasDisponiveisChange = (date) => {
        setDataDisponivel(date);

        if (!date) {
            setSelectedDataId(null);
            return;
        }

        const idEncontrado = Object.keys(datasFotografia).find(key => {
            const dataOriginal = new Date(datasFotografia[key]);
            
            // Zera as horas de ambas para garantir que a comparação seja apenas dia/mês/ano
            dataOriginal.setHours(0, 0, 0, 0);
            const dataSelecionada = new Date(date);
            dataSelecionada.setHours(0, 0, 0, 0);

            return dataOriginal.getTime() === dataSelecionada.getTime();
        });

        if (idEncontrado) {
            console.log("ID Selecionado:", idEncontrado);
            setSelectedDataId(idEncontrado);
        }
    }

    const campoObrigatorio = (titulo, descricao, icon) => {
        Swal.fire({
            title: titulo,
            html: `${descricao}`,
            icon: icon,
            confirmButtonText: "OK",
        });
    };

    const getHitorico = async() => {
        if (!selectedEmpresa) { campoObrigatorio("Atenção", "Preencha uma Empresa para Pesquisar", "warning"); return false; }
        if (!dataDisponivel) { campoObrigatorio("Atenção", "Preencha uma Data Disponível para Pesquisar", "warning"); return false; }
        setIsSearch(true);
        setisLoading(true);

        try {
            let params = `IdEmpresa=${idEmpresa}&IdDataFotografia=${selectedDataId}`;
            const responseHistorico= await api.get(`Wip/historico/${selectedDataId}`);
            setListHistorico(responseHistorico.data.data);
        } catch (error) {
            console.error("Erro ao buscar histórico", error);
        } finally {
            setisLoading(false);
            // setselectedEmpresa(null);
            // setEmpresaId(null);
            // setDataDisponivel(null);
            // setIsDataDisponivel(false);
        }
    }

    const refreshData = async () => {
        setselectedEmpresa(null);
        setEmpresaId(null);
        setDataDisponivel(null);
        setIsDataDisponivel(false);
    };

    //
    useEffect(() => {
        const asyncFn = async () => {
            const empresas = localStorage.getItem('empresasUsuario') ? JSON.parse(localStorage.getItem('empresasUsuario')) : [];
            const empresaList = await getEmpresas();
            if (!!empresaList) {
                setEmpresaList(empresaList.filter(empresa => empresas.indexOf(empresa.idEmpresa) > -1))
            }
        }

        asyncFn().then((values) => {
            var formValues = {}
            formData(formValues);

        })
    }, [null, 0, 10]);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">WIP Histórico</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="row">
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                <StyledForm onSubmit={handleSubmit(getHitorico)}>
                                    <div className="row">
                                        <div className="form-container d-flex flex-column justify-content-center px-0 col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DynamicSelect
                                                placeholder={''}
                                                valuetext={selectedEmpresa}
                                                label={'Selecione a empresa'}
                                                name={'idEmpresa'}
                                                options={empresaList}
                                                keyValue={'idEmpresa'}
                                                keyLabel={'description'}
                                                paramMethod={getEmpresa}
                                                clearOption={true} />
                                        </div>
                                        <style>{`
                                            /* Foca apenas no calendário que tiver a classe 'sem-fundo-azul' */
                                            .sem-fundo-azul .react-datepicker__day--selected,
                                            .sem-fundo-azul .react-datepicker__day--keyboard-selected {
                                                background-color: transparent !important;
                                                color: #000 !important; /* Ou a cor do texto que você usa */
                                                font-weight: normal !important;
                                            }
                                            
                                            /* Mantém o hover cinza para o usuário saber que pode clicar */
                                            .sem-fundo-azul .react-datepicker__day:hover {
                                                background-color: #f0f0f0 !important; 
                                            }
                                        `}</style>
                                        <div className="form-container d-flex flex-column justify-content-center px-0 col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                calendarClassName="sem-fundo-azul"
                                                selected={dataDisponivel}
                                                onChange={handleDatasDisponiveisChange}
                                                placeholderText={'Datas Disponíveis'}
                                                includeDates={datasDisponiveis}
                                                disabled={!isDataDisponivel}
                                            />
                                        </div>
                                        <div className="form-container d-flex flex-column justify-content-center px-0 col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                            <input type="submit" className='default-button-red' value='Pesquisar' />
                                        </div>
                                    </div>
                            </StyledForm>
                            </div>
                        </div>

                        <br />
                        { isSearch &&
                        <>
                            <div className="row mb-2" style={{ fontSize: "14px" }}>
                                <div className="col-4 text-center"><span style={{ fontWeight: "bold" }}>Empresa</span><br/>{ listHistorico?.wipHistorico?.empresa }</div>
                                <div className="col-4 text-center"><span style={{ fontWeight: "bold" }}>Data da Fotografia</span><br/>{ new Date(listHistorico?.wipHistorico?.dataHistorico).toLocaleString('pt-BR') }</div>
                                <div className="col-4 text-center"><span style={{ fontWeight: "bold" }}>Qtd. Timesheets</span><br/>{ listHistorico?.wipHistorico?.qtdTimesheet }</div>
                            </div>
                            <div className="row" style={{ fontSize: "14px" }}>
                                <div className="col-4 text-center"><span style={{ fontWeight: "bold" }}>Total Horas</span><br/>{ listHistorico?.wipHistorico?.totalHorasFaturadas.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</div>
                                <div className="col-4 text-center"><span style={{ fontWeight: "bold" }}>Total Valor</span><br/>{ listHistorico?.wipHistorico?.valorTotalFaturado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 }) }</div>
                                <div className="col-4 text-center"><span style={{ fontWeight: "bold" }}>Total Desconto</span><br/>{ listHistorico?.wipHistorico?.valorTotalDesconto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 }) }</div>
                            </div>
                            <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                            
                            
                            {isLoading ? <StldRow>
                                <div className="text-center">
                                    <div className="align-items-center">
                                        <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        <div><strong style={{ color: "#EE4B21" }}>{isLoading ? 'Carregando...' : 'Pesquisando...'}</strong></div>
                                    </div>
                                </div>
                            </StldRow> : (
                                <StldRow>
                                    {
                                        listHistorico?.resumo != null && listHistorico?.resumo.length > 0 ? (
                                            listHistorico?.resumo.map((item, index) => {
                                                console.log("item", item.visao);
                                                return (
                                                    <StldColumn key={index} xs="12" sm="6" md="4" lg="4" xl="4">
                                                        <StyledCardWIPHistorico>
                                                            <div className="card-align">
                                                                <Flex className={'title-legend'}>
                                                                    <div className="flex-title-center" style={{width: "100%"}}>
                                                                        <span className="legend-title-text-bold">{item?.visao}</span>
                                                                    </div>
                                                                </Flex>

                                                                <StyledTablePage>
                                                                    <table className="table table-bordered table-width">
                                                                        <thead>
                                                                            <tr className="table-legend-info">
                                                                                <th key='0'></th>
                                                                                <th key='1'>Qtd.TS </th>
                                                                                <th key='2'>Horas</th>
                                                                                <th key='3'>Valor</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr key={"-1"} className={'primeiro-ativo-wip'}>
                                                                                <td className="text-center">Total</td>
                                                                                <td className="text-center">{item.totalTimesheet}</td>
                                                                                <td className="text-center">{item.totalHoras.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                                <td className="text-center">{item.totalValor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</td>
                                                                            </tr>
                                                                            {item.disciplinas.map((visao, index) => (
                                                                                <tr key={index}>
                                                                                    <td className="text-center">{visao.sigla}</td>
                                                                                    <td className="text-center">{visao.qtdTimesheet}</td>
                                                                                    <td className="text-center">{visao.totalHorasFaturadas.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                                    <td className="text-center">{visao.possuiDesconto ? "*" : ""} {visao.valorTotalFaturado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </StyledTablePage>
                                                            </div>
                                                        </StyledCardWIPHistorico>
                                                    </StldColumn>
                                                )
                                            })
                                        ) : (
                                            <StldColumn xs="12" sm="12" md="12">
                                                <div className="alert alert-warning" role="alert">
                                                    Atenção! Nenhum resultado encontrado para Critério Experts!
                                                </div>
                                            </StldColumn>)
                                    }
                                </StldRow>
                            )
                            }
                        </>
                        }
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};

export const WIPHistoricoPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <WIPHistorico />

                </>
            )}
        </>
    );
};